import * as PostMessage from './postMessages';

const {iframe} = window.YC;

const scrollTo = (element: HTMLElement, position?: ScrollLogicalPosition) => {
    if (iframe) {
        const offset = element.offsetTop;
        PostMessage.sendIframeOffset(offset);
    } else {
        element.scrollIntoView({behavior: 'smooth', block: position});
        element.focus({preventScroll: true});
    }
};
export default scrollTo;
